import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';

// 인증 관련
import { AuthProvider } from './contexts/AuthContext';
import { UsageProvider } from './contexts/UsageContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import { setupAxiosInterceptors } from './utils/axiosConfig';
import Login from './pages/Login';
import Signup from './pages/Signup';
import UserProfile from './pages/UserProfile';

// 기존 페이지들
import Client_demo from './pages/client_demo';
import Card_news from './pages/card_news';
import Card_news_reserve from './pages/card_news_reserve';
import Card_dashboard from './pages/card_dashboard';
import Scenario_management from './pages/scenario_management';
import Test from './pages/test';

function App() {
  useEffect(() => {
    // axios 인터셉터 설정
    setupAxiosInterceptors();
  }, []);

  return (
    <div className="App">
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true
        }}
      >
        <AuthProvider>
          <UsageProvider>
          <Layout>
            <Routes>
              {/* 공개 라우트 */}
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              
              {/* 보호된 라우트 - 로그인 필요 */}
              <Route path="/" element={
                <ProtectedRoute>
                  <Card_news />
                </ProtectedRoute>
              } />
              <Route path="/profile" element={
                <ProtectedRoute>
                  <UserProfile />
                </ProtectedRoute>
              } />
              <Route path="/client_demo" element={
                <ProtectedRoute>
                  <Client_demo />
                </ProtectedRoute>
              } />
              <Route path="/card_news_reserve" element={
                <ProtectedRoute>
                  <Card_news_reserve />
                </ProtectedRoute>
              } />
              <Route path="/card_dashboard" element={
                <ProtectedRoute>
                  <Card_dashboard />
                </ProtectedRoute>
              } />
              <Route path="/scenario_management" element={
                <ProtectedRoute>
                  <Scenario_management />
                </ProtectedRoute>
              } />
              <Route path="/test" element={
                <ProtectedRoute>
                  <Test />
                </ProtectedRoute>
              } />
              
              {/* 404 페이지 */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Layout>
          </UsageProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;